import React, { useState, useRef, useCallback } from "react";
import { HexAlphaColorPicker, HexColorInput, HexColorPicker } from "react-colorful";
import { useClickOutsideMonitorHook } from "./click-outside";
import "./color-picker.styles.css";

/**
 * @author Pradeep R <pradeep.rajendran@rldatix.com>
 * @createdOn Jan/21/2025
 */
export default function ColorPickerDialog(
    { color, onChange }:
        {
            color: string;
            onChange: (color: string) => void;
        }
) {

    const popover = useRef<HTMLDivElement>(null);
    const presetColors = [
        "#eb9694", "#fad0c3", "#fef3bd", "#c1e1c5", "#bedadc", "#c4def6", "#bed3f3", "#d4c4fb", "#FFFFFF",
        "#b80000", "#db3e00", "#fccb00", "#008b02", "#006b76", "#1273de", "#004dcf", "#5300eb", "#000000",
    ];
    const [isOpen, toggle] = useState(false);

    const close = useCallback(() => toggle(false), []);
    useClickOutsideMonitorHook(popover, close);

    return (
        <div className="picker" >
            <div
                className="swatch"
                style={{ backgroundColor: color }}
                onClick={() => toggle(true)}
            />

            {isOpen && (
                <div className="popover" ref={popover}>
                    <HexAlphaColorPicker color={color} onChange={onChange} />
                    <div className="picker__swatches">
                        {presetColors.map((presetColor) => (
                            <button
                                key={presetColor}
                                className="picker__swatch"
                                style={{ background: presetColor }}
                                onClick={() => onChange(presetColor)}
                            />
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};